/**
 * 宝箱可开出的食物（与 Pet 食物商城一致）
 * 命名、图片、goods_id 与食物商城完全一致
 */
import food1 from 'asset/img/pet-food1.webp';
import food2 from 'asset/img/pet-food2.webp';
import food3 from 'asset/img/pet-food3.webp';
import food4 from 'asset/img/pet-food4.webp';

export const TREASURE_FOOD_LIST = [
  { goods_id: '72db4051-7fc7-44ad-a4df-e16a3c21d478', name: '香蕉', image: food1 },
  { goods_id: '3cc68a42-529c-4b2a-8d0b-1db08b55e6cf', name: '蟠桃', image: food2 },
  { goods_id: '3a4c0427-c8d6-48ad-9c8e-386f5737efcf', name: '人参果', image: food3 },
  { goods_id: 'b4da0908-4aea-40b4-b20d-e88ddc42e22d', name: '老君仙丹', image: food4 },
];

// 食物权重（越贵越难抽）：香蕉 35% | 蟠桃 30% | 人参果 22% | 老君仙丹 13%（仙丹类提升）
const FOOD_WEIGHTS = [35, 30, 22, 13];

/** 65% 概率开出食物，按权重随机（香蕉最易、老君仙丹最难）；35% 仅金币 */
export function rollTreasureFood() {
  if (Math.random() >= 0.65) return null;
  const r = Math.random() * 100;
  let acc = 0;
  for (let i = 0; i < FOOD_WEIGHTS.length; i++) {
    acc += FOOD_WEIGHTS[i];
    if (r < acc) return TREASURE_FOOD_LIST[i];
  }
  return TREASURE_FOOD_LIST[TREASURE_FOOD_LIST.length - 1];
}
